//not used anymore. replaced with product-add-on-multiple
class ProductAddOn extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      cta: this.querySelector('select.add-on-select'),
      optionElement: this.querySelector('option.add-on'),
      id: this.querySelector('option.add-on').dataset.id,
      forProduct: this.querySelector('option.add-on').dataset.product,
      atc: document.querySelector('.product-info__block-list .buy-buttons .button'),
      form: document.querySelector('form[action="/cart/add"]'),
      masuraInelSelect: document.querySelector('select[name="properties[Măsură inel]"'),
      addOnChanged: false,
    };
    
    this.elements.cta.addEventListener('change', (e) => {
      this.elements.addOnChanged = true;
      this.elements.id = this.elements.cta.options[this.elements.cta.selectedIndex].dataset.id;
      this.elements.optionElement = this.elements.cta.options[this.elements.cta.selectedIndex];
      this.elements.property = this.elements.cta.options[this.elements.cta.selectedIndex].dataset.property;
      this.elements.optionElement.setAttribute('data-added', 'yes');
    })
    this.elements.atc.addEventListener('click', (e) => {
      if(this.elements.addOnChanged) {
          e.preventDefault();
          if(this.elements.masuraInelSelect.value == '') {
            alert('Selectează măsură inel');
            return;
          } else {
            this.addToCart().then(()=> {
              this.elements.form.submit();
            })
          }
        }
    })
  }
  addToCart() {
    let formData = {
      'items': [{
       'id': this.elements.id,
       'quantity': 1,
       'properties': {
          "Măsură verighetă pentru": this.elements.property 
        }
       }]
     };

     return fetch(window.Shopify.routes.root + 'cart/add.js', {
       method: 'POST',
       headers: {
         'Content-Type': 'application/json'
       },
       body: JSON.stringify(formData)
     })
     .then(response => {
       return response.json();
     })
     .then(() => {
      this.elements.optionElement.setAttribute('data-added', 'yes');
     })
     .catch((error) => {
       console.error('Error:', error);
     });
     
  }

}

customElements.define('product-add-on', ProductAddOn);
